import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Alert, Button, Field, Input } from '../ui/basics';
import { Icon } from '../ui/icons';
import { rules, useFormValidation } from '../validation';

const SCHEMA = { email: [rules.required('Email'), rules.email('Email')], password: rules.required('Password') };

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const v = useFormValidation({ email, password }, SCHEMA);

  if (user) return <Navigate to={user.must_change_password ? '/change-password' : '/'} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!v.check()) return;
    setBusy(true);
    try {
      const signedIn = await login(email.trim(), password);
      navigate(signedIn.must_change_password ? '/change-password' : '/', { replace: true });
    } catch (err) {
      setError(err.status === 429 ? 'Too many attempts. Please wait a minute and try again.' : err.message);
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <span className="shape s1" aria-hidden="true" />
      <span className="shape s2" aria-hidden="true" />
      <span className="shape s3" aria-hidden="true" />
      <span className="shape s4" aria-hidden="true" />
      <section className="form-panel">
        <form onSubmit={submit} noValidate>
          <div className="logo-tile"><img src="/VivyaLogo.png" alt="VivyaHire Finance" width="96" height="96" /></div>
          <div className="form-head">
            <span className="brand-name">VivyaHire Finance</span>
            <h1>Welcome Back</h1>
            <p>Sign in to continue</p>
          </div>
          {error && <Alert>{error}</Alert>}
          <Field label="Email" className="plain" error={v.shown('email')}>
            <div className="with-icon">
              <span className="lead"><Icon name="mail" size={20} /></span>
              <Input type="email" autoComplete="username" autoFocus required value={email} placeholder="Work email" aria-label="Email"
                onChange={(e) => setEmail(e.target.value)} {...v.props('email')} />
            </div>
          </Field>
          <Field label="Password" className="plain">
            <div className="with-icon">
              <span className="lead"><Icon name="lock" size={20} /></span>
              <Input type={show ? 'text' : 'password'} autoComplete="current-password" required value={password} placeholder="Password" aria-label="Password"
                onChange={(e) => setPassword(e.target.value)} />
              <button type="button" className="reveal" onClick={() => setShow(!show)} aria-label={show ? 'Hide password' : 'Show password'}>
                <Icon name={show ? 'eye' : 'eyeoff'} size={20} />
              </button>
            </div>
          </Field>
          <Button variant="primary" className="signin" loading={busy} disabled={busy || !email || !password} type="submit">
            <span>Sign in</span>
            {!busy && <span className="go"><Icon name="arrow" size={20} /></span>}
          </Button>
          <p className="help">Need access or can't sign in? Contact your administrator.</p>
        </form>
        <p className="tagline">Performance <i /> Placements <i /> Onboarding</p>
      </section>
    </div>
  );
}
